<template>
  <div class="w-full">
    <vs-table search pagination max-items="10" :data="segmentos">
      <template slot="header">
        <vs-row vs-w="12">
          <vs-col vs-w="6">
            <h4 style="color: #B4AA99">Segmentos</h4>
          </vs-col>
          <vs-col vs-w="6">
            <ModalCadastroSegmento @update="getSegmentos" />
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th sort-key="nome">Segmento</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :state="data[indextr].lixeira == 1 ? 'danger' : ''"
          :key="indextr"
          v-for="(tr, indextr) in data"
        >
          <vs-td :data="data[indextr].nome">{{ data[indextr].nome }}</vs-td>
          <vs-td class="actions">
            <ModalEditarSegmento
              :segmento="data[indextr]"
              @update="getSegmentos"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="segmentos.length == 0">
        <div class="con-colors">
            <ul>
              <li class="danger-box">
                <h2 class="p-5" style="color: white !important">Nenhum segmento cadstrado</h2>
              </li>
            </ul>
          </div>
      </div>
  </div>
</template>

<script>
import ModalCadastroSegmento from "./cadastro.vue";
import ModalEditarSegmento from "./editar.vue";

export default {
  data() {
    return {
      segmentos: []
    };
  },
  methods: {
    async getSegmentos() {
      this.$vs.loading();
      try {
        this.segmentos = await this.$http.get(`segmento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
      }
    }
  },
  components: {
    ModalCadastroSegmento,
    ModalEditarSegmento
  },
  mounted() {
    this.getSegmentos();
  }
};
</script>

<style>
.actions {
  width: 60px !important;
}
</style>
